module.exports = __webpack_public_path__ + "img/delete.425d84eb.svg";